import {fromJS, Map} from 'immutable';
import {combineReducers} from 'redux-immutable';

import paginatorReducer from '../../paginator/reducer';
import treeReducer from '../tree/reducer';
import Questions from './component';
import mainReducer from './reducer';


export const initialState = {};

const _reducer = combineReducers({
    main: mainReducer,
    paginator: paginatorReducer,
    materialsTreeFilter: treeReducer,
    subjectsTreeFilter: treeReducer,
    labelsTreeFilter: treeReducer,
    typesTreeFilter: treeReducer,
    levelsTreeFilter: treeReducer,
    gradesTreeFilter: treeReducer,
    statusesTreeFilter: treeReducer,
    questionDialog: combineReducers({
        materialsTree: treeReducer,
        subjectsTree: treeReducer,
        labelsTree: treeReducer,
        typesTree: treeReducer,
        questionLevelsTree: treeReducer,
        statusesTree: treeReducer,
        levelsTree: treeReducer,
        gradesTree: treeReducer,
    }),
    selected: q => q || new Map(),
});
export const reducer = (state, action) => {
    if (!state.get('main')) {
        const id = state.get('elementId') || window.uuidv4();
        state = fromJS({
            main: {currentQuestion: {}, elementId: id},
        });
    }
    state = _reducer(state, action);
    state = state.set('selected', state.get('paginator').get('selected'));
    return state;
};
export const component = Questions;
